const placeholderQuotes = [
  "Start writing, no matter what. The water does not flow until the faucet is turned on. - Louis Lu'Amour",
  "Get it down. Take chances. It may be bad, but it's the only way you can do anything really good. - William Faulkner",
  "The first draft is just you telling yourself the story. - Terry Pratchett",
  "Start before you're ready. - Steven Pressfield",
  "You cannogt wait for inspiration. You have to go after it with a club. - Jack London",
  "I have never started a poem yet whose end I knew. Writing a poem is discovering. - Robert Frost",
  "If there's a book that you want to read, but it hasn't been written yet, then you must write it. - Toni Morrison",
  "To produce a mighty book, you must choose a mighty theme. - Herman Melville",
  "Description begins in the writeru's imagination but should finish in the readeru's. - Stephen King",
  "No tears in the writer, no tears in the reader. No surprise in the writer, no surprise in the reader. - Robert Frost",
  "Never write anything that does not give you great pleasure. Emotion is easily transferred from the writer to the reader. - Joseph ",
  "It is perfectly okay to write garbage as long as you edit brilliantly. - C. J. Cherryh",
  "Half my life is an act of revision. - John Irving",
  "Writing without revising is the literary equivalent of waltzing gaily out of the house in your underwear. - Patricia Fuller",
  "Write your first draft with your heart. Rewrite with your head. - Mike Rich",
  "So the writer who breeds more words than he needs, is making a chore for the reader who reads. - Dr. Seuss",
  "Outside of a dog, a book is manu's best friend. Inside of a dog, itu's too dark to read. - Groucho Marx",
  "If you have no critics, youu'll likely have no success. - Malcolm X",
  "If the book is true, it will find an audience that is meant to read it. - Wally Lamb",
  "I went for years not finishing anything. Because, of course, when you finish something you can be judged. - Erica Jong",
  "If I waited for perfection, I would never write a word. - Margaret Atwood",
  "Difficulties mastered are opportunities won. - Winston Churchill",
  "Ignore all hatred and criticism. Live for what you create, and die protecting it. - Lady Gaga",
  "You can make anything by writing. - C.S. Lewis",
  "The true alchemists do not change lead into gold; they change the world into words. - William H. Gass",
  "Imagination is everything. It is the preview of lifeu's coming attractions. - Albert Einstein",
  "Words are our most inexhaustible source of magic. - J. K. Rowling",
  "I must write it all out, at any cost. Writing is thinking. It is more than living, for it is being conscious of living. - Anne Morrow ",
  "I can shake off everything as I write; my sorrows disappear, my courage is reborn. - Anne Frank",
] as string[];

const getRandomPlaceholderQuote = () => {
  const randomNumber = Math.floor(Math.random() * placeholderQuotes.length);
  const randomQuote = placeholderQuotes[randomNumber];
  return randomQuote;
};

export default getRandomPlaceholderQuote;
